import React, { Component } from 'react';
import { Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

import { StopsListDataIdentifierCommonForm } from './StopsListDataIdentifierCommonForm';

export class HorizontalStopsListDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let textRotationAngle = "90";
        let stopsListConfiguration = {
            showOnlyInSpineStops: false,
            hideNonInSpineStops: false,
            hidePreviousStops: false,
            hideZoneLimitStops: false,
            hideStopsWithMapPoint: false,
            shrinkText: false,
            showStopCaps: false,
            showStopCode: false,
            stopCodePrecendentText: "",
            stopCodeSubsequentText: "",
            durationBackgroundBuilderComponent: 0,
            zonesBackgroundBuilderComponent: 0,
            zoneTextRotationAngle: 0,
        };

        if (null !== this.props.selectedData && undefined !== this.props.selectedData) {
            const splitedData = this.props.selectedData.split("|%|");

            textRotationAngle = splitedData[0];
            if (1 < splitedData.length) {
                stopsListConfiguration = Object.assign(stopsListConfiguration, JSON.parse(splitedData[1]));
            }
        }

        this.state = {
            form: {
                textRotationAngle: textRotationAngle,
                showOnlyInSpineStops: stopsListConfiguration.showOnlyInSpineStops,
                hideNonInSpineStops: stopsListConfiguration.hideNonInSpineStops,
                hidePreviousStops: stopsListConfiguration.hidePreviousStops,
                hideZoneLimitStops: stopsListConfiguration.hideZoneLimitStops,
                hideStopsWithMapPoint: stopsListConfiguration.hideStopsWithMapPoint,
                shrinkText: stopsListConfiguration.shrinkText,
                showStopCaps: stopsListConfiguration.showStopCaps,
                showStopCode: stopsListConfiguration.showStopCode,
                stopCodePrecendentText: stopsListConfiguration.stopCodePrecendentText,
                stopCodeSubsequentText: stopsListConfiguration.stopCodeSubsequentText,
                durationBackgroundBuilderComponent: stopsListConfiguration.durationBackgroundBuilderComponent,
                zonesBackgroundBuilderComponent: stopsListConfiguration.zonesBackgroundBuilderComponent,
                zoneTextRotationAngle: stopsListConfiguration.zoneTextRotationAngle,
            },
            styles: {
                textRotationAngle: null
            }
        };
    }

    // -----------------------

    onSelectData() {
        const { form } = this.state;

        const styles = {
            textRotationAngle: null
        }

        if (0 >= form.textRotationAngle.length || 10 > form.textRotationAngle || 90 < form.textRotationAngle) {
            styles.textRotationAngle = "error"
        }

        if (null == styles.textRotationAngle) {
            const stopsListConfiguration = {
                showOnlyInSpineStops: form.showOnlyInSpineStops,
                hideNonInSpineStops: form.hideNonInSpineStops,
                hidePreviousStops: form.hidePreviousStops,
                hideZoneLimitStops: form.hideZoneLimitStops,
                hideStopsWithMapPoint: form.hideStopsWithMapPoint,
                shrinkText: form.shrinkText,
                showStopCaps: form.showStopCaps,
                showStopCode: form.showStopCode,
                stopCodePrecendentText: form.stopCodePrecendentText,
                stopCodeSubsequentText: form.stopCodeSubsequentText,
                durationBackgroundBuilderComponent: form.durationBackgroundBuilderComponent,
                zonesBackgroundBuilderComponent: form.zonesBackgroundBuilderComponent,
                zoneTextRotationAngle: form.zoneTextRotationAngle,
            };
            this.props.onSelectData(`${form.textRotationAngle}|%|${JSON.stringify(stopsListConfiguration)}`, true);
        }
        else {
            this.setState({
                styles: styles
            });
        }
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeSelectValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    // -----------------------

    render() {
        const { form, styles } = this.state;

        return (
            <Form>
                <FormGroup
                    bsSize="small"
                    controlId="formDataTextRotationAngle"
                    validationState={styles.textRotationAngle} >
                    <ControlLabel>Rotação do Texto a Apresentar [10..90]</ControlLabel>
                    <FormControl
                        type="number"
                        step={1}
                        min={10}
                        max={90}
                        placeholder="Ângulo de Rotação"
                        value={form.textRotationAngle}
                        onChange={(e) => this.onChangeValue(e, "textRotationAngle")} />
                </FormGroup>

                <StopsListDataIdentifierCommonForm 
                    form={form}
                    onChangeValue={(a, b) => this.onChangeValue(a, b)}
                    onChangeCheckboxValue={(a) => this.onChangeCheckboxValue(a)}
                    onChangeSelectValue={(a, b) => this.onChangeSelectValue(a, b)}
                    onCancel={this.props.onCancel}
                    onSelectData={() => this.onSelectData()} />
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/HorizontalStopsListDataIdentifier.js